import _asyncToGenerator from "/Users/adway/Documents/agora.io/ad-manage-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/adway/Documents/agora.io/ad-manage-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { captcha } from '@/api/user';
export default {
  name: 'Login',
  data: function data() {
    var checkUsername = function checkUsername(rule, value, callback) {
      if (value.length < 5) {
        return callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };

    var checkPassword = function checkPassword(rule, value, callback) {
      if (value.length < 6) {
        return callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };

    return {
      curYear: 0,
      lock: 'lock',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaId: ''
      },
      rules: {
        username: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }]
      },
      logVerify: '',
      picPath: ''
    };
  },
  created: function created() {
    this.loginVerify();
    this.curYear = new Date().getFullYear();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginIn'])), {}, {
    oauth2: function oauth2() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.location.href = 'https://oauth.agoralab.co/oauth/authorize?response_type=code&client_id=toYtRi2w9896gu8VNHkawiNuAcunWckd&state=ad&redirect_uri=https%3A%2F%2Fad-manage-web.sh3.agoralab.co%2Fapi%2Foauth%2Fcallback';

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    oauthTest: function oauthTest() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.location.href = 'https://oauth.agoralab.co/oauth/authorize?response_type=code&client_id=toYtRi2w9896gu8VNHkawiNuAcunWckd&state=ad&redirect_uri=https%3A%2F%2Ftest-ad-manage-web.sh3.agoralab.co%2Fapi%2Foauth%2Fcallback';

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    login: function login() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.LoginIn(_this.loginForm);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    submitForm: function submitForm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this2.$refs.loginForm.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(v) {
                    var flag;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!v) {
                              _context4.next = 7;
                              break;
                            }

                            _context4.next = 3;
                            return _this2.login();

                          case 3:
                            flag = _context4.sent;

                            if (!flag) {
                              _this2.loginVerify();
                            }

                            _context4.next = 10;
                            break;

                          case 7:
                            _this2.$message({
                              type: 'error',
                              message: '请正确填写登录信息',
                              showClose: true
                            });

                            _this2.loginVerify();

                            return _context4.abrupt("return", false);

                          case 10:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    changeLock: function changeLock() {
      this.lock = this.lock === 'lock' ? 'unlock' : 'lock';
    },
    loginVerify: function loginVerify() {
      var _this3 = this;

      captcha({}).then(function (ele) {
        _this3.picPath = ele.data.picPath;
        _this3.loginForm.captchaId = ele.data.captchaId;
      });
    }
  })
};